/* AudioLearn 2026 — product review and marketplace analytics. */
(function (window, document) {
  'use strict';

  var analyticsState = window.AudioLearnReviewAnalytics || {};
  if (analyticsState.initialized) return;

  analyticsState.initialized = true;
  analyticsState.viewedProducts = analyticsState.viewedProducts || {};
  analyticsState.observedReviewRoots = analyticsState.observedReviewRoots || [];
  window.AudioLearnReviewAnalytics = analyticsState;

  var reviewRootSelector = [
    '[data-audiolearn-reviews]',
    '[data-audiolearn-review-section]',
    '[data-audiolearn-reviews-list]',
    '[data-audiolearn-reviews-view][role="tabpanel"]',
    'section[data-audiolearn-reviews-view]',
    '[data-pdp-panel="reviews"]'
  ].join(',');

  var reviewCardSelector = [
    '[data-audiolearn-review]',
    '[data-review-card]',
    '.audiolearn-review-card',
    '.pdp-review-card',
    '.review-card'
  ].join(',');

  var marketplaceSelector = [
    '[data-marketplace]',
    '[data-audiolearn-marketplace]',
    '[data-audiolearn-marketplace-link]',
    '[data-marketplace-review-link]'
  ].join(',');

  function matchesSelector(element, selector) {
    var matcher;
    if (!element || element.nodeType !== 1) return false;
    matcher = element.matches || element.msMatchesSelector || element.webkitMatchesSelector;
    if (!matcher) return false;
    try {
      return matcher.call(element, selector);
    } catch (error) {
      return false;
    }
  }

  function closest(element, selector) {
    var current = element && element.nodeType === 1 ? element : element && element.parentElement;
    while (current && current !== document) {
      if (matchesSelector(current, selector)) return current;
      current = current.parentElement;
    }
    return null;
  }

  function firstAttribute(element, names) {
    var current = element;
    var index;
    var value;
    while (current && current !== document) {
      if (current.getAttribute) {
        for (index = 0; index < names.length; index += 1) {
          value = current.getAttribute(names[index]);
          if (value !== null && value !== '') return value;
        }
      }
      current = current.parentElement;
    }
    return '';
  }

  function documentAttribute(names) {
    var index;
    var element;
    var value;
    for (index = 0; index < names.length; index += 1) {
      try {
        element = document.querySelector('[' + names[index] + ']');
      } catch (error) {
        element = null;
      }
      if (element) {
        value = element.getAttribute(names[index]);
        if (value !== null && value !== '') return value;
      }
    }
    return '';
  }

  function metaProductValue(property) {
    var sources = [];
    var index;
    try {
      if (window.meta && window.meta.product) sources.push(window.meta.product);
    } catch (error) {
      /* A storefront analytics object must never be allowed to break the page. */
    }
    try {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        sources.push(window.ShopifyAnalytics.meta.product);
      }
    } catch (error) {
      /* Continue through the remaining identity fallbacks. */
    }
    for (index = 0; index < sources.length; index += 1) {
      if (sources[index][property] !== null && typeof sources[index][property] !== 'undefined') {
        return sources[index][property];
      }
    }
    return '';
  }

  function productHandleFromPath() {
    var match;
    try {
      match = window.location.pathname.match(/\/products\/([^\/?#]+)/i);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function productId(element) {
    var value = firstAttribute(element, ['data-product-id', 'data-audiolearn-product-id']);
    if (value === '') value = documentAttribute(['data-product-id', 'data-audiolearn-product-id']);
    if (value === '') value = metaProductValue('id');
    return value === null || typeof value === 'undefined' ? '' : value;
  }

  function productHandle(element) {
    var value = firstAttribute(element, ['data-product-handle', 'data-audiolearn-product-handle']);
    if (value === '') value = documentAttribute(['data-product-handle', 'data-audiolearn-product-handle']);
    if (value === '') value = metaProductValue('handle');
    if (value === '') value = productHandleFromPath();
    return value === null || typeof value === 'undefined' ? '' : value;
  }

  function documentPageLocation() {
    try {
      return window.location.href || '';
    } catch (error) {
      return '';
    }
  }

  function pageLocation(element) {
    var explicit = firstAttribute(element, ['data-page-location']);
    if (explicit) return explicit;
    if (closest(element, '[data-marketplace-feedback], .pdp-marketplace-feedback')) return 'marketplace_feedback';
    if (closest(element, '.pdp-hero, [data-product-hero], [data-audiolearn-product-hero]')) return 'product_hero';
    if (closest(element, '[data-audiolearn-direct-reviews], ' + reviewCardSelector)) return 'audiolearn_reviews';
    if (closest(element, '[data-pdp-tab="reviews"], [data-audiolearn-review-tab]')) return 'product_tabs';
    if (closest(element, reviewRootSelector + ', [data-audiolearn-reviews-view]')) return 'audiolearn_reviews';
    return documentPageLocation();
  }

  function eventPayload(element, marketplace) {
    var payload = {
      product_id: productId(element),
      product_handle: productHandle(element),
      page_location: pageLocation(element),
      marketplace: marketplace || 'audiolearn'
    };
    return payload;
  }

  function pushToDataLayer(eventName, payload) {
    var record;
    var property;
    try {
      if (!window.dataLayer || typeof window.dataLayer.push !== 'function') return false;
      record = { event: eventName };
      for (property in payload) {
        if (Object.prototype.hasOwnProperty.call(payload, property)) record[property] = payload[property];
      }
      window.dataLayer.push(record);
      return true;
    } catch (error) {
      return false;
    }
  }

  function emitCustomEvent(eventName, payload) {
    var event;
    try {
      if (typeof window.CustomEvent === 'function') {
        event = new window.CustomEvent(eventName, { bubbles: true, detail: payload });
      } else if (document.createEvent) {
        event = document.createEvent('CustomEvent');
        event.initCustomEvent(eventName, true, false, payload);
      }
      if (!event) return false;
      document.dispatchEvent(event);
      return true;
    } catch (error) {
      return false;
    }
  }

  function publish(eventName, payload) {
    var publication;
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        publication = window.Shopify.analytics.publish(eventName, payload);
        if (publication && typeof publication.catch === 'function') {
          publication.catch(function () {
            if (!pushToDataLayer(eventName, payload)) emitCustomEvent(eventName, payload);
          });
        }
        return;
      }
    } catch (error) {
      /* Fall through to the storefront-neutral transports. */
    }
    if (!pushToDataLayer(eventName, payload)) emitCustomEvent(eventName, payload);
  }

  function track(eventName, element, marketplace) {
    try {
      publish(eventName, eventPayload(element, marketplace));
    } catch (error) {
      /* Analytics must be fail-safe and must never interrupt an interaction. */
    }
  }

  function viewedProductKey(element) {
    var id = productId(element);
    var handle = productHandle(element);
    return 'product:' + String(id || handle || documentPageLocation() || 'unknown');
  }

  function trackReviewsViewed(element) {
    var key = viewedProductKey(element);
    if (analyticsState.viewedProducts[key]) return;
    analyticsState.viewedProducts[key] = true;
    track('audiolearn_reviews_viewed', element);
  }

  function normalizedMarketplace(value) {
    value = String(value || '').toLowerCase();
    if (value.indexOf('amazon') !== -1) return 'amazon';
    if (value.indexOf('audible') !== -1) return 'audible';
    return '';
  }

  function marketplaceFromHref(element) {
    var link = closest(element, 'a[href]');
    var parser;
    var host;
    if (!link) return '';
    try {
      parser = document.createElement('a');
      parser.href = link.getAttribute('href');
      host = String(parser.hostname || '').toLowerCase();
      if (/(^|\.)amazon\.[a-z.]+$/.test(host) || /(^|\.)amzn\.to$/.test(host)) return 'amazon';
      if (/(^|\.)audible\.[a-z.]+$/.test(host)) return 'audible';
    } catch (error) {
      return '';
    }
    return '';
  }

  function marketplaceFor(element) {
    var marker = closest(element, marketplaceSelector);
    var value = '';
    if (marker) {
      value = marker.getAttribute('data-marketplace') ||
        marker.getAttribute('data-audiolearn-marketplace') ||
        marker.getAttribute('data-audiolearn-marketplace-link') ||
        marker.getAttribute('data-marketplace-review-link') || '';
      value = normalizedMarketplace(value);
    }
    return value || marketplaceFromHref(element);
  }

  function reviewTargetValue(element) {
    var interactive = closest(element, 'a[href], button, [role="button"]');
    if (!interactive) return '';
    return String(
      interactive.getAttribute('href') ||
      interactive.getAttribute('aria-controls') ||
      interactive.getAttribute('data-target') ||
      interactive.getAttribute('data-scroll-target') ||
      interactive.getAttribute('data-pdp-scroll-target') ||
      interactive.getAttribute('data-pdp-open-tab') || ''
    ).toLowerCase();
  }

  function isReviewsScrollTrigger(element) {
    var explicitSelector = [
      '[data-audiolearn-reviews-scroll]',
      '[data-reviews-section-scroll]',
      '[data-reviews-scroll-trigger]',
      '[data-audiolearn-review-summary]',
      '[data-audiolearn-reviews-summary]',
      '[data-review-summary]',
      '[data-review-summary-link]',
      '[data-pdp-open-tab="reviews"]'
    ].join(',');
    var explicit = closest(element, explicitSelector);
    var target;
    if (explicit) return !matchesSelector(explicit, '[data-pdp-tab="reviews"]');
    if (!closest(element, '.pdp-hero, [data-product-hero], [data-audiolearn-product-hero]')) return false;
    target = reviewTargetValue(element);
    return target.indexOf('review') !== -1;
  }

  function reviewsViewTrigger(element) {
    return closest(element, [
      '[data-pdp-tab="reviews"]',
      '[data-audiolearn-reviews-view]',
      '[data-audiolearn-review-tab]'
    ].join(','));
  }

  function isHidden(element) {
    var current = element;
    var styles;
    while (current && current !== document) {
      if (current.hidden || current.getAttribute('aria-hidden') === 'true') return true;
      try {
        styles = window.getComputedStyle ? window.getComputedStyle(current) : null;
        if (styles && (styles.display === 'none' || styles.visibility === 'hidden')) return true;
      } catch (error) {
        /* Attribute checks are sufficient when computed styles are unavailable. */
      }
      current = current.parentElement;
    }
    return false;
  }

  function reviewRoots() {
    try {
      return Array.prototype.slice.call(document.querySelectorAll(reviewRootSelector));
    } catch (error) {
      return [];
    }
  }

  function trackActiveReviewsView() {
    var activeTab;
    var roots;
    var index;
    try {
      activeTab = document.querySelector('[data-pdp-tab="reviews"][aria-selected="true"], [data-audiolearn-review-tab][aria-selected="true"]');
    } catch (error) {
      activeTab = null;
    }
    if (activeTab) {
      trackReviewsViewed(activeTab);
      return;
    }
    roots = reviewRoots();
    for (index = 0; index < roots.length; index += 1) {
      if (!isHidden(roots[index]) && matchesSelector(roots[index], '[data-pdp-panel="reviews"]')) {
        trackReviewsViewed(roots[index]);
        return;
      }
    }
  }

  function isDirectReviewExpansion(element) {
    if (closest(element, marketplaceSelector)) return false;
    if (closest(element, '[data-audiolearn-review-expand]')) return true;
    if (closest(element, reviewCardSelector)) return true;
    return Boolean(closest(element, reviewRootSelector) && closest(element, 'details'));
  }

  function expansionTrigger(element) {
    var trigger = closest(element, '[data-audiolearn-review-expand]');
    if (trigger) return trigger;
    trigger = closest(element, 'summary, [aria-expanded]');
    return trigger && isDirectReviewExpansion(trigger) ? trigger : null;
  }

  function expansionOwner(trigger) {
    return closest(trigger, reviewCardSelector) || closest(trigger, 'details') || trigger;
  }

  function isExpanded(trigger) {
    var details = matchesSelector(trigger, 'details') ? trigger : closest(trigger, 'details');
    var expanded;
    var controlled;
    if (details) return Boolean(details.open);
    expanded = trigger.getAttribute('aria-expanded');
    if (expanded !== null) return expanded === 'true';
    controlled = trigger.getAttribute('aria-controls');
    if (controlled) {
      controlled = document.getElementById(controlled);
      if (controlled) return !controlled.hidden && controlled.getAttribute('aria-hidden') !== 'true';
    }
    return matchesSelector(trigger, '[data-audiolearn-review-expand]');
  }

  function trackReviewExpanded(trigger) {
    var owner;
    if (!trigger || !isDirectReviewExpansion(trigger) || !isExpanded(trigger)) return;
    owner = expansionOwner(trigger);
    if (owner.__audiolearnReviewExpansionTracked) return;
    owner.__audiolearnReviewExpansionTracked = true;
    track('audiolearn_review_expanded', trigger);
  }

  function handleClick(event) {
    var element = event.target;
    var marketplace = marketplaceFor(element);
    var viewTrigger = reviewsViewTrigger(element);
    var expandTrigger = expansionTrigger(element);

    if (marketplace === 'amazon') track('amazon_review_link_clicked', element, marketplace);
    if (marketplace === 'audible') track('audible_review_link_clicked', element, marketplace);
    if (isReviewsScrollTrigger(element)) track('reviews_section_scrolled_to', element);
    if (viewTrigger && matchesSelector(viewTrigger, 'a, button, [role="tab"], [role="button"]')) {
      trackReviewsViewed(viewTrigger);
    }
    if (expandTrigger) {
      window.setTimeout(function () { trackReviewExpanded(expandTrigger); }, 0);
    }
  }

  function handleKeydown(event) {
    var key = event.key || event.keyCode;
    if (!closest(event.target, '[data-pdp-tab], [data-audiolearn-review-tab]')) return;
    if (key === 'ArrowLeft' || key === 'ArrowRight' || key === 'Home' || key === 'End' ||
        key === 35 || key === 36 || key === 37 || key === 39) {
      window.setTimeout(trackActiveReviewsView, 0);
    }
  }

  function handleToggle(event) {
    var details = event.target;
    if (matchesSelector(details, 'details') && details.open && isDirectReviewExpansion(details)) {
      trackReviewExpanded(details);
    }
  }

  function observeReviewRoots() {
    var roots = reviewRoots();
    var index;
    var root;
    if (!analyticsState.reviewObserver && typeof window.IntersectionObserver === 'function') {
      analyticsState.reviewObserver = new window.IntersectionObserver(function (entries) {
        var entryIndex;
        for (entryIndex = 0; entryIndex < entries.length; entryIndex += 1) {
          if (entries[entryIndex].isIntersecting && entries[entryIndex].intersectionRatio > 0) {
            trackReviewsViewed(entries[entryIndex].target);
          }
        }
      }, { threshold: 0.15 });
    }
    for (index = 0; index < roots.length; index += 1) {
      root = roots[index];
      if (analyticsState.observedReviewRoots.indexOf(root) !== -1) continue;
      analyticsState.observedReviewRoots.push(root);
      if (analyticsState.reviewObserver) analyticsState.reviewObserver.observe(root);
    }
  }

  function observeReviewControls() {
    var controls;
    var index;
    if (typeof window.MutationObserver !== 'function') return;
    if (!analyticsState.reviewMutationObserver) {
      analyticsState.reviewMutationObserver = new window.MutationObserver(trackActiveReviewsView);
      analyticsState.observedReviewControls = [];
    }
    try {
      controls = document.querySelectorAll('[data-pdp-tab="reviews"], [data-audiolearn-review-tab], [data-pdp-panel="reviews"]');
    } catch (error) {
      controls = [];
    }
    for (index = 0; index < controls.length; index += 1) {
      if (analyticsState.observedReviewControls.indexOf(controls[index]) !== -1) continue;
      analyticsState.observedReviewControls.push(controls[index]);
      analyticsState.reviewMutationObserver.observe(controls[index], {
        attributes: true,
        attributeFilter: ['aria-selected', 'hidden']
      });
    }
  }

  function initializeReviewViews() {
    observeReviewRoots();
    observeReviewControls();
    trackActiveReviewsView();
  }

  document.addEventListener('click', handleClick, true);
  document.addEventListener('keydown', handleKeydown, true);
  document.addEventListener('toggle', handleToggle, true);
  document.addEventListener('shopify:section:load', initializeReviewViews);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeReviewViews);
  } else {
    initializeReviewViews();
  }
}(window, document));
